'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _templateObject = _taggedTemplateLiteral(['\n  background-color: ', ';\n  border: 0;\n  height: 1px;\n\n  /* Set min-height and width so that it will never be shrunk inside a flex container */\n  min-height: 1px;\n  width: 100%;\n'], ['\n  background-color: ', ';\n  border: 0;\n  height: 1px;\n\n  /* Set min-height and width so that it will never be shrunk inside a flex container */\n  min-height: 1px;\n  width: 100%;\n']);

exports.default = HR;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classNames = require('react-utils/classNames');

var _classNames2 = _interopRequireDefault(_classNames);

var _DistanceConstants = require('../layout/DistanceConstants');

var _theme = require('HubStyleTokens/theme');

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var StyledHR = _styledComponents2.default.hr.withConfig({
  displayName: 'HR__StyledHR'
})(_templateObject, _theme.HR_BORDER_COLOR);

var getClasses = function getClasses(className, distance) {
  return (0, _classNames2.default)('namespaced-hack-hr', className, _DistanceConstants.DISTANCE_CLASSES[distance]);
};

function HR(_ref) {
  var className = _ref.className,
      distance = _ref.distance,
      rest = _objectWithoutProperties(_ref, ['className', 'distance']);

  return _react2.default.createElement(StyledHR, _extends({}, rest, { className: getClasses(className, distance) }));
}

HR.propTypes = {
  className: _react.PropTypes.string,
  distance: _react.PropTypes.oneOf(Object.keys(_DistanceConstants.DISTANCE_CLASSES)).isRequired
};

HR.defaultProps = {
  distance: 'medium'
};

HR.displayName = 'HR';
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.1755/js/elements/HR.js
// module id = 499
// module chunks = 2 3